webpackJsonp([218122631423814],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _MobileGeographySectionModule = __webpack_require__(203);
	
	var _MobileGeographySectionModule2 = _interopRequireDefault(_MobileGeographySectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _Animations = __webpack_require__(5);
	
	var _imgMobileShippingZones = __webpack_require__(250);
	
	var _imgMobileShippingZones2 = _interopRequireDefault(_imgMobileShippingZones);
	
	var _imgMobileShippingZones2x = __webpack_require__(251);
	
	var _imgMobileShippingZones2x2 = _interopRequireDefault(_imgMobileShippingZones2x);
	
	var _imgMobileShippingZones3x = __webpack_require__(252);
	
	var _imgMobileShippingZones3x2 = _interopRequireDefault(_imgMobileShippingZones3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-components----MobileGeographySection-module---mobile-geography-section---_LHhu' },
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { component: _reactstrap.Container, className: 'src-components----MobileGeographySection-module---container---2KSr2' },
	            _react2.default.createElement(
	                _Animations.TweenOne,
	                _extends({ key: 'text-container', className: 'src-components----MobileGeographySection-module---text-container---1o8ld' }, _Animations.FadeUp),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'On the go?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Take your data with you.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----MobileGeographySection-module---message---2KGWj' },
	                    'We know you can\u2019t always be at your desk. That\u2019s why Galleon is optimized for mobile phones and tablets, too.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { className: 'src-components----MobileGeographySection-module---button---a-QT7', to: '/contact' },
	                    'Try free for 7 days'
	                )
	            ),
	            _react2.default.createElement(
	                _Animations.TweenOne,
	                _extends({ key: 'splash-image-container',
	                    className: 'src-components----MobileGeographySection-module---splash-image-container---2LM81'
	                }, _Animations.FadeLeft),
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_imgMobileShippingZones2.default, _imgMobileShippingZones2x2.default, _imgMobileShippingZones3x2.default],
	                    className: 'src-components----MobileGeographySection-module---splash-image---3q1eU' }),
	                _react2.default.createElement('div', { className: 'src-components----MobileGeographySection-module---touch-dot-1---3uZTH' }),
	                _react2.default.createElement('div', { className: 'src-components----MobileGeographySection-module---touch-dot-2---3PbV6' })
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mobile-geography-section":"src-components----MobileGeographySection-module---mobile-geography-section---_LHhu","container":"src-components----MobileGeographySection-module---container---2KSr2","text-container":"src-components----MobileGeographySection-module---text-container---1o8ld","message":"src-components----MobileGeographySection-module---message---2KGWj","button":"src-components----MobileGeographySection-module---button---a-QT7","splash-image-container":"src-components----MobileGeographySection-module---splash-image-container---2LM81","splash-image":"src-components----MobileGeographySection-module---splash-image---3q1eU","touch-dot-1":"src-components----MobileGeographySection-module---touch-dot-1---3uZTH","touch-dot-2":"src-components----MobileGeographySection-module---touch-dot-2---3PbV6"};

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _TeamDetailsSectionModule = __webpack_require__(663);
	
	var _TeamDetailsSectionModule2 = _interopRequireDefault(_TeamDetailsSectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _imgLaptopZoneAndWeight = __webpack_require__(49);
	
	var _imgLaptopZoneAndWeight2 = _interopRequireDefault(_imgLaptopZoneAndWeight);
	
	var _imgLaptopZoneAndWeight2x = __webpack_require__(50);
	
	var _imgLaptopZoneAndWeight2x2 = _interopRequireDefault(_imgLaptopZoneAndWeight2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-components----TeamDetailsSection-module---team-details-section---2ScdR' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-components----TeamDetailsSection-module---text-container---S_RDr' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Team management so easy'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'It\'s almost cheating.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----TeamDetailsSection-module---features-table---3iI6y' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----TeamDetailsSection-module---feature-row---1s7dh' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----TeamDetailsSection-module---heading---37Xn4' },
	                            'Invite'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Onboard with ease. In a few clicks, you can invite anyone to Galleon. Every new seat is eligible for a free tutorial on the platform.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----TeamDetailsSection-module---feature-row---1s7dh' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----TeamDetailsSection-module---heading---37Xn4' },
	                            'Remove'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Tie off loose ends. Don\u2019t let departing employees leave with access to your most sensitive customer data \u2014 simply remove their user, and permissions are immediately revoked.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----TeamDetailsSection-module---feature-row---1s7dh' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----TeamDetailsSection-module---heading---37Xn4' },
	                            'Customize'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Make it yours. Every user can deploy filters, download data and schedule reports independently, without interrupting their teammates.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-components----TeamDetailsSection-module---splash-image-container---1AlPg' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgLaptopZoneAndWeight2.default, _imgLaptopZoneAndWeight2x2.default],
	                className: 'src-components----TeamDetailsSection-module---splash-image---UjKy-'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"team-details-section":"src-components----TeamDetailsSection-module---team-details-section---2ScdR","text-container":"src-components----TeamDetailsSection-module---text-container---S_RDr","message":"src-components----TeamDetailsSection-module---message---2v78W","features-table":"src-components----TeamDetailsSection-module---features-table---3iI6y","feature-row":"src-components----TeamDetailsSection-module---feature-row---1s7dh","heading":"src-components----TeamDetailsSection-module---heading---37Xn4","splash-image-container":"src-components----TeamDetailsSection-module---splash-image-container---1AlPg","splash-image":"src-components----TeamDetailsSection-module---splash-image---UjKy-"};

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-hands.f8ecd90a.jpg";

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-hands@2x.effd088d.jpg";

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-hands@3x.ba7bcc46.jpg";

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-mobile-shipping-zones.f6eb97d2.png";

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-mobile-shipping-zones@2x.54a7f061.png";

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-mobile-shipping-zones@3x.8ef595ca.png";

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dashboardModule = __webpack_require__(55);
	
	var _dashboardModule2 = _interopRequireDefault(_dashboardModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _TeamDetailsSection = __webpack_require__(373);
	
	var _TeamDetailsSection2 = _interopRequireDefault(_TeamDetailsSection);
	
	var _FeaturesLinksSection = __webpack_require__(51);
	
	var _FeaturesLinksSection2 = _interopRequireDefault(_FeaturesLinksSection);
	
	var _MobileGeographySection = __webpack_require__(155);
	
	var _MobileGeographySection2 = _interopRequireDefault(_MobileGeographySection);
	
	var _TestimonialsSection = __webpack_require__(91);
	
	var _TestimonialsSection2 = _interopRequireDefault(_TestimonialsSection);
	
	var _imgHands = __webpack_require__(785);
	
	var _imgHands2 = _interopRequireDefault(_imgHands);
	
	var _imgHands2x = __webpack_require__(786);
	
	var _imgHands2x2 = _interopRequireDefault(_imgHands2x);
	
	var _imgHands3x = __webpack_require__(787);
	
	var _imgHands3x2 = _interopRequireDefault(_imgHands3x);
	
	var _iconTeams = __webpack_require__(244);
	
	var _iconTeams2 = _interopRequireDefault(_iconTeams);
	
	var _iconTeams2x = __webpack_require__(245);
	
	var _iconTeams2x2 = _interopRequireDefault(_iconTeams2x);
	
	var _iconTeams3x = __webpack_require__(246);
	
	var _iconTeams3x2 = _interopRequireDefault(_iconTeams3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-pages-features----dashboard-module---hero---RX6K-' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages-features----dashboard-module---text-container---3CHyn' },
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_iconTeams2.default, _iconTeams2x2.default, _iconTeams3x2.default] }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h1 mt-2' },
	                    'Teams'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Many hands make light work.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-pages-features----dashboard-module---message---TYnoZ' },
	                    'What do a customer service rep, a cost accountant and the COO all have in common? They all need to know what\u2019s going on with your shipping. And now they can, with team management. Effortlessly assign and revoke accounts across your org, and let individual users access the data they need.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { className: 'src-pages-features----dashboard-module---button---3mu4_', to: '/contact' },
	                    'Try free for 7 days'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-pages-features----dashboard-module---splash-image-container---1iBIF', style: { width: '650px' } },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgHands2.default, _imgHands2x2.default, _imgHands3x2.default],
	                className: 'src-pages-features----dashboard-module---splash-image---1LZSu'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(Hero, null),
	        _react2.default.createElement(_TeamDetailsSection2.default, null),
	        _react2.default.createElement(_MobileGeographySection2.default, null),
	        _react2.default.createElement(_TestimonialsSection2.default, null),
	        _react2.default.createElement(_FeaturesLinksSection2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-teams-js-bfc7039b3fbe44c4d8ac.js